import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import PaymentDrawyer from "./DrawyerPages/PaymentDrawyer";

export const OverViewPayment: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getPaymentPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const [open, setOpen] = React.useState(false);
  const id = params?.id;
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [resetLoad, setResetLoad] = useState(false)
  const [formComponent, setFormComponent] = useState<any>()
  const isMobile = IsSmallScreen();
  const [paymentData, setPaymentData] = useState<any>([])
  const columns: IColumns[] = [
    {
      header: "Date",
      fieldName: "paymentDate",
      tooltip: true,
      type: 'date'
    },
    {
      header: "Amount",
      fieldName: "amountReceived",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Method",
      fieldName: "paymentMethod",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ]
  useEffect(() => {
  
      const getPayment = async () => {
        try {
          setResetLoad(false)
          const response: any = await callAPI(`payment-receives/lead`, Method.GET, null, id);
            setPaymentData(response?.data);
          }
  
        
        catch (e) {
  
        }
      }
      getPayment();
    }, [resetLoad])
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      const form: any = <PaymentDrawyer
        id="paymentrawyer"
        data={row}
        paymentId={row?.id}
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }
  }
  const handlePaymentData = async (data: any) => {
    try {
      dispatch(storeDataComponent('paymentSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        reset()
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        setResetLoad(true)
        showMessage('Product Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(false)
    }
    finally {
      dispatch(updateDataComponent('paymentSubmit', { loading: false }));
    }

  }
  const saveData = async (data: any) => {

    const request: any = {
      "leadId": id,
      "amountReceived": Number(data?.amountReceived),
      "paymentMethod": data?.paymentMethod,
      "transactionReference": data?.transactionReference,
      "notes": data?.notes

    }
    if (data?.paymentId) {

      const response: any = await callAPI(`payment-receives`, Method.PUT, request,data.paymentId);
      return response
    } else {
      const response: any = await callAPI("payment-receives", Method.POST, request);
      return response
    }
  }

  const handlePaymentClick = () => {
    setOpen(true)
    const form: any =
      <PaymentDrawyer
        id="paymentrawyer"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false) }}
      />

    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }
console.log('paymentData===>',paymentData)
  return (
    <Grid>
      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="paymentDealsGrid"
            title="Payments"
            columns={columns}
            data={paymentData}
            addButton={add?{ label: "New", color: "secondary" }:undefined}
            onAddButtonClick={handlePaymentClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
          : <PermissionDenied />
        }
      </Grid>
      <SwipeableDrawerForm anchor="right" title={'Payments'}
        openForm={open}
        formComponent={<form onSubmit={handleSubmit(handlePaymentData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
    </Grid>
  );
});
